import React from 'react';
import { useParams } from 'react-router-dom';
import UpdateClassified from './UpdateClassified';
import EditClassifiedBreadCrumb from './EditClassifiedBreadCrumb';

function EditClassifiedPage() {
    const { id } = useParams(); // Get the classified ID from URL

    return (
        <div className="container-fluid">
            <EditClassifiedBreadCrumb />
            <UpdateClassified classifiedId={id} /> {/* Pass ID to UpdateClassified */}
        </div>
    );
}

export default EditClassifiedPage;
